/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_ue_full_uri = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Full URI (keep :/?&=)`)
};

const es_ue_full_uri = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`URI completa (mantener :/?&=)`)
};

const de_ue_full_uri = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vollständige URI (behalte :/?&=)`)
};

const nl_ue_full_uri = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volledige URI (behoud :/?&=)`)
};

const fr_ue_full_uri = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`URI complet (garder :/?&=)`)
};

const it_ue_full_uri = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`URI completo (mantieni :/?&=)`)
};

const pt_br2_ue_full_uri = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`URI completa (manter :/?&=)`)
};

const pt_ue_full_uri = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`URI completo (manter :/?&=)`)
};

const ja_ue_full_uri = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`完全なURI (:/?&= を保持)`)
};

const zh_ue_full_uri = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`完整 URI（保留 :/?&=）`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const ue_full_uri = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.ue_full_uri(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("ue_full_uri", locale)
	if (locale === "en") return en_ue_full_uri(inputs)
	if (locale === "es") return es_ue_full_uri(inputs)
	if (locale === "de") return de_ue_full_uri(inputs)
	if (locale === "nl") return nl_ue_full_uri(inputs)
	if (locale === "fr") return fr_ue_full_uri(inputs)
	if (locale === "it") return it_ue_full_uri(inputs)
	if (locale === "pt-BR") return pt_br2_ue_full_uri(inputs)
	if (locale === "pt") return pt_ue_full_uri(inputs)
	if (locale === "ja") return ja_ue_full_uri(inputs)
	return zh_ue_full_uri(inputs)
};